// extracted by mini-css-extract-plugin
module.exports = {"depositIcons":"deposit-footer_depositIcons__LLJ2T","depositIcon":"deposit-footer_depositIcon__fdVGq"};